export function normalize_time(array, time_index) {
    let copied = false;
    let output = array;
    for (let i = 0; i < array.length; i++) {
        const time = output[i][time_index];
        if (time < 0) {
            if (!copied) {
                output = array.slice();
                copied = true;
            }
            output[i] = output[i].slice();
            output[i][time_index] = output[i - 1][time_index] - time;
        }
    }
    return output;
}
/**
 * !! RepeatingValueProcessor если есть в python, то нужно убрать add_gaps
 * @param array
 * @param gap_width
 */
export function add_gaps(array, gap_width = 3 * 60) {
    const output = [];
    let prevtime = null;
    for (const item of array) {
        if (prevtime != null && item[0] - prevtime > gap_width)
            output.push([prevtime + 1, null]);
        output.push(item);
        prevtime = item[0];
    }
    return output;
}
export function time_mul_1k(array) {
    const output = new Array(array.length);
    for (let i = 0; i < array.length; i++) {
        output[i] = array[i].slice();
        output[i][0] *= 1e3;
    }
    return output;
}
export function make_staircase(array, step_width = 1) {
    // step_width is in milliseconds
    if (array.length == 0)
        return [];
    const output = [];
    let last_time = null;
    let last_value = null;
    for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const time = item[0];
        if (last_time != null && time - last_time > step_width)
            output.push([time - step_width, last_value]);
        output.push(item);
        [last_time, last_value] = item;
    }
    return output;
}
